import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/typography/index.shared';

export default styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.SUBTITLE.MOBILE}px;
`;
